// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/css/styles.css
// module id = 2815
// module chunks = 0